// Entry point 
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import App_main from './App_main';
import './styles_main/global.css';
import './styles_main/components.css';
import './styles_main/components-enhanced.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
   <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
    <App_main />
  </Router>
);